import config from "@shared/config/client";
import { ICallableRequestBuilder } from "../requestBuilder/types";
import {
  AuctionOrder,
  BaseSignedOrder,
  OfferOrder,
  ReserveAuctionOrder,
} from "./types";
import queryString from "query-string";
import { EnrichedObject } from "../types";
import { Nft } from "../nfts/types";

const getOrdersForNft =
  (request: ICallableRequestBuilder<any>) => (nftId: string) => {
    return request.call(`${config.apiUrl}/orders/nft/${nftId}`, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const getOrderForNfts =
  (request: ICallableRequestBuilder<BaseSignedOrder[]>) =>
  (nftIds: string[]) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/orders/by-nft-ids`,
      query: {
        nftIds,
      },
    });
    return request.call(url);
  };

const getCollectionOfferForBidder =
  (request: ICallableRequestBuilder<any>) => (address: string) => {
    return request.call(
      `${config.apiUrl}/orders/offers/collection/${address}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const getOffersForNft =
  (request: ICallableRequestBuilder<OfferOrder[]>) => (nftId: string) => {
    return request.call(`${config.apiUrl}/orders/offers/${nftId}`, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const getReserveBidsForNft =
  (request: ICallableRequestBuilder<ReserveAuctionOrder[]>) =>
  (nftId: string) => {
    return request.call(
      `${config.apiUrl}/orders/reserve-bids/${nftId}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const getLatestAuctions =
  (request: ICallableRequestBuilder<AuctionOrder[]>) => () => {
    return request.call(`${config.apiUrl}/orders/auctions`, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const getAuctionForNFT =
  (request: ICallableRequestBuilder<AuctionOrder>) => (nftId: string) => {
    return request.call(
      `${config.apiUrl}/orders/auction/nft/${nftId}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const getReceivedOffers =
  (
    request: ICallableRequestBuilder<EnrichedObject<OfferOrder, "nft", Nft>[]>,
  ) =>
  (take = 20, skip = 0) => {
    const query = {
      take,
      skip,
    };

    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/orders/offers/received`,
      query,
    });

    return request.call(url);
  };

const getMadeOffers =
  (request: ICallableRequestBuilder<OfferOrder[]>) =>
  (take = 20, skip = 0) => {
    const query = {
      take,
      skip,
    };

    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/orders/offers/made`,
      query,
    });

    return request.call(url);
  };

const calculateNftExchangeFee =
  (request: ICallableRequestBuilder<any>) => (nftId: string) => {
    return request.call(
      `${config.apiUrl}/orders/calculateServiceFee/nft/${nftId}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const calculateCollectionExchangeFee =
  (request: ICallableRequestBuilder<any>) => (collectionId: string) => {
    return request.call(
      `${config.apiUrl}/orders/calculateServiceFee/collection/${collectionId}`,
      (init) => ({
        ...init,
        method: "GET",
      }),
    );
  };

const requests = {
  getOffersForNft,
  getOrdersForNft,
  getReserveBidsForNft,
  getReceivedOffers,
  getLatestAuctions,
  getAuctionForNFT,
  getCollectionOfferForBidder,
  getMadeOffers,
  getOrderForNfts,
  calculateNftExchangeFee,
  calculateCollectionExchangeFee,
};

export default requests;
